/**
 * Route for `google-ads-gclid-capture`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GoogleAdsGclidCapturePage } from "../features/google-ads-gclid-capture/GoogleAdsGclidCapturePage";

export const googleAdsGclidCaptureRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/google-ads-gclid-capture",
	component: GoogleAdsGclidCapturePage,
});

export default googleAdsGclidCaptureRoute;
